export async function downloadApk(): Promise<void> {
  const res = await fetch("/api/apks/download");
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message ?? "Nenhum APK disponível para download.");
  }
  const { url } = await res.json();
  window.location.href = url;
}
